import { Component, ViewChild,OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';
let k=1;
@Component({
  selector: 'app-completed-orders',
  templateUrl: './completed-orders.component.html',
  styleUrls: ['./completed-orders.component.scss'],
})
export class CompletedOrdersComponent {
  loader:boolean=true;
  slideOpts={
    loop:false,
    effect: 'slide',
    slidesPerView: 4,
    spaceBetween: 8
  }
  itemtypeObj=[{id:1,name:'Completed Orders',clicked:false,status:3},
  {id:2,name:'Partially Fixed Orders',clicked:false,status:11},]
  orderItems:any=[];
  orderItemsFull:any=[];
  array=[];
  popLoad:boolean=false;
  filterItems:any=[];
  category:any=[];
  date=new Date();
  status;
  notes;
  closeing:boolean=false;
  itemOrders:any;
  openPop:boolean;
  search;
  dateFormat;
  serviceRequest:any=[];
  datailstatus;
  purrchaseItems;
  criditValue;
  data;
  config;
  config1;
  userValue;
  constructor(public service: ApiService,
    public handler: HandlerService,
    public router: Router,
    public auth:AuthService) { }


  ionViewWillEnter(){
    sessionStorage.setItem('vendorApp','true');
    this.dateFormat = this.auth.getDateformat();
    this.getCategory();
    this.getConfig();
    this.itemtypeObj.map(res=>{
      if(res.id==1){
      this.status=res.status  
      res.clicked=true;
      }
    })
  }
  async getConfig(){
    this.data= await this.service.getConfig().toPromise();
    if(this.data){
       let x= this.data.find(res=>res.name=="Billing Config");
       this.config=x.configs.find(dat=>dat.shortCdConst=="TVC");
       this.config1 = x.configs.find(dat=>dat.shortCdConst=="ACP");
       this.userValue=this.config.userValue; 
       this.criditValue=this.config1.userValue;

    }
  }
  itemObj(data){
    this.orderItems=[];
    data.clicked = ! data.clicked;
    this.itemtypeObj.map(res=>{
      if(data.id == res.id){
        this.status=res.status
        Object.assign(res,{clicked:true})
        this.getCategory();
      }else{
        Object.assign(res,{clicked:false})
      }
    })
  }

  getAllOrderbydate(date) {
    this.orderItems=[];
    this.loader=true;
    k=1;
    this.service.getAllOrderByDate(this.returnDate(date),k).subscribe((res: any) => {
      if(res){
      this.orderItems = res;
      this.orderItems = this.orderItems.filter(res=>{ return res.status==this.status&&res.serviceContractor.userId==localStorage.getItem('currentUserId')})
      this.orderItems.map(res => {
        Object.assign(res, { clicked: false })
      })  
      this.orderItems.map(dat=>{
       this.category.map(dat1=>{
         if(dat.categoryId==dat1.id)
         Object.assign(dat, {categoryName: dat1.name})   
       })
       if(dat.paymtStatus==1)
       Object.assign(dat, {payStatusName: "Not Paid"})
       if(dat.paymtStatus==2)
       Object.assign(dat, {payStatusName: "Paid"})    
       if(dat.status==7)
       Object.assign(dat, {reqStatusName:"Pending Allocation"})   
       if(dat.status==2)
       Object.assign(dat, {reqStatusName:"Completed"})
       if(dat.status==5)
       Object.assign(dat, {reqStatusName:"Cancelled"})
       if(dat.status==10)
       Object.assign(dat, {reqStatusName:"Scheduled"})   
       if(dat.status==9)
       Object.assign(dat, {reqStatusName:"Assigned"})
       if(dat.status==11)
       Object.assign(dat, {reqStatusName:"Partially Fixed"})
       if(dat.appt==true)
       Object.assign(dat, {serviceFlat:dat.flatName})
       if(dat.appt==false)
       Object.assign(dat, {serviceFlat:dat.street})
       if(dat.appt=="" || dat.appt== undefined )
       Object.assign(dat, {serviceFlat:"Not Specified"})
      })   
      this.loader=false; 
      k++;
    } else{
      this.orderItems=[];
      this.loader=false;
      this.handler.res('No Data For You ')


    } 
    },err=>{
      this.orderItems=[];
      this.loader=false;
    }) 
}
  getAllOrder() {
    this.orderItems=[];
    this.loader=true;
    k=1;
    this.service.getAllOrderByStatus(localStorage.getItem('currentUserId'),this.status,k).subscribe((res: any) => {
      if(res){
      this.orderItems = res; 
      this.filterItems = res;
      this.orderItems.map(dat=>{
       this.category.map(dat1=>{
         if(dat.categoryId==dat1.id)
         Object.assign(dat, {categoryName: dat1.name})   
       })
       if(dat.paymtStatus==1)
       Object.assign(dat, {payStatusName: "Not Paid"})
       if(dat.paymtStatus==2)
       Object.assign(dat, {payStatusName: "Paid"})    
       if(dat.status==7)
       Object.assign(dat, {reqStatusName:"Pending Allocation"})   
       if(dat.status==2)
       Object.assign(dat, {reqStatusName:"Completed"})
       if(dat.status==5)
       Object.assign(dat, {reqStatusName:"Cancelled"})
       if(dat.status==10)
       Object.assign(dat, {reqStatusName:"Scheduled"})   
       if(dat.status==9)
       Object.assign(dat, {reqStatusName:"Assigned"})
       if(dat.status==11)
       Object.assign(dat, {reqStatusName:"Partially Fixed"})
       if(dat.appt==true)
       Object.assign(dat, {serviceFlat:dat.flatName})
       if(dat.appt==false)
       Object.assign(dat, {serviceFlat:dat.street})
       if(dat.appt=="" || dat.appt== undefined )
       Object.assign(dat, {serviceFlat:"Not Specified"})
      })
      this.loader=false; 
      k++;
    } else{
      this.orderItems=[];
      this.loader=false;
      this.handler.res('No Data For You ')
    } 
    },err=>{
      this.orderItems=[];
      this.loader=false;
    }) 
}
returnDate(data) {
  let date = data.getDate();
  date = date < 10 ? '0' + date : date;
 let month = data.getMonth() + 1;
 month = month < 10 ? '0' + month : month;
 let year = data.getFullYear();
 return year + '-' + month + '-' + date; 
}
getCategory() {
  this.service.getOrgCategory().subscribe((res: any) => {
    this.category = res;
    this.getAllOrder();
  })
}
popUpOpen(data){
  this.getOrder(data)
  // this.itemOrders = data.itemOrders;
  // this.serviceRequest = data.serviceRequests;
  // this.itemOrders.map(res=>{
  //   this.serviceRequest.map(dat=>{
  //     if(res.itemId == dat.providerServiceId){
  //      this.datailstatus = dat.status
  //     }
  //   })
  // })
  // if(this.datailstatus == 3){
  //   Object.assign(this.itemOrders.itemDetails,{statusName:'Completed'})
  // }else{
  //   Object.assign(this.itemOrders.itemDetails,{statusName:'Not Fixed'})
  // }
  
  this.openPop = true;
}

getOrder(data){
  this.popLoad=true;
  this.service.getOrderById(data.id).subscribe((res:any) => {
    if (res) {
     this.purrchaseItems = res.serviceRequests;
     this.notes = res.notes;
     this.purrchaseItems.map(dat=>{
     if(dat.status == 3){      
        Object.assign(dat,{statusName:'Completed'})      
      }else{
        Object.assign(dat,{statusName:'Not Fixed'})
      }
    })
     this.popLoad =false;
    }
  },
    err => {
      this.popLoad = false;
      this.handler.err(err.error)
    })
}
getCust(val){
  let x = val.length;  
  this.orderItems=[];
  if(x > 0){  
  this.closeing=true;   
    this.service.searchOrderByCust(val).subscribe((res: any) => {  
      if (res != null && res != "NO_CONTENT" && res.length > 0) {          
        this.loader = false;  
        this.orderItemsFull = res;
        this.orderItemsFull = this.orderItemsFull.filter(res=>{ return res.status==this.status&&res.serviceContractor.userId==localStorage.getItem('currentUserId')})
        this.orderItemsFull.map(res1 => {
          Object.assign(res1, {value:val})
         })
    
        this.orderItemsFull.map(res1=>{
          this.array.push(res1)
        }) 
         this.orderItems = this.array.filter(res2 => {return res2.value == this.search});        
        if(this.search == "" || this.search == undefined){          
        this.orderItems = this.filterItems;
        this.closeing=false;
        }       
      }else{   
        this.orderItems = [];       
        this.handler.res("No Data Found");      
      }
    }, err => {
      this.loader = false;
      this.handler.err(err);
    })
  }
}
clear(){
  this.search="";
  this.closeing=false;
  this.orderItems=this.filterItems;
  this.ionViewWillEnter();
}
ordersByPage($event){
    this.loader=true;
    this.service.getAllOrderByStatus(localStorage.getItem('currentUserId'),this.status,k).subscribe((res: any) => {
      if(res){
      res.map(dat1=>{
        this.orderItems.push(dat1)
      })
      console.log(this.orderItems)
      res.map(dat1=>{
        this.filterItems.push(dat1)
      })
      this.orderItems.map(dat=>{
       this.category.map(dat1=>{
         if(dat.categoryId==dat1.id)
         Object.assign(dat, {categoryName: dat1.name})   
       })
       if(dat.paymtStatus==1)
       Object.assign(dat, {payStatusName: "Not Paid"})
       if(dat.paymtStatus==2)
       Object.assign(dat, {payStatusName: "Paid"})    
       if(dat.status==7)
       Object.assign(dat, {reqStatusName:"Pending Allocation"})   
       if(dat.status==2)
       Object.assign(dat, {reqStatusName:"Completed"})
       if(dat.status==5)
       Object.assign(dat, {reqStatusName:"Cancelled"})
       if(dat.status==10)
       Object.assign(dat, {reqStatusName:"Scheduled"})   
       if(dat.status==9)
       Object.assign(dat, {reqStatusName:"Assigned"})
       if(dat.status==11)
       Object.assign(dat, {reqStatusName:"Partially Fixed"})
       if(dat.appt==true)
       Object.assign(dat, {serviceFlat:dat.flatName})
       if(dat.appt==false)
       Object.assign(dat, {serviceFlat:dat.street})
       if(dat.appt=="" || dat.appt== undefined )
       Object.assign(dat, {serviceFlat:"Not Specified"})
      })
      this.loader=false; 
      k++;
    } else{
      this.loader=false;
      this.handler.res('No Data For You ')
    } 
    },err=>{
      this.loader=false;
    }) 
}

}
